export default "__VITE_ASSET__LDuQg7fm__"